module.exports = __webpack_public_path__ + "static/media/location-icon.e160499b.svg";